<template>
  <header class="site-header text-light">
    <div class="container-herohire">
      <div class="site-header-inner">
        <div class="brand header-brand">
          <h1 class="m-0">
            <a href="#">
              <img
                class="header-logo-image"
                src="@/assets/herohire-logo.png"
                alt="Logo"
                width="150"
              />
            </a>
          </h1>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header'
};
</script>

<style>
</style>
